import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Ship } from '@classes/ship';
// import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _moment from 'moment';
import { EnvConfigurationService } from './env-configuration.service';
const moment = _moment;

@Injectable({
  providedIn: 'root'
})
export class ShipService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/ship';

  public ships = new BehaviorSubject<Array<Ship>>([]);

  lastUpdate: _moment.Moment;

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getShips(forceRefresh?: boolean): Observable<Array<Ship>> {
    if (this.ships.value.length && this.lastUpdate.isBefore(moment().add(this.environment.refreshListSecond, 'second')) && !forceRefresh) {
      return of(this.ships.value);
    }
    return this.http.get<Array<Ship>>(this.basePath).pipe(
      map(m => {
        this.ships.next(m);
        this.lastUpdate = moment();
        return m;
      })
    );
  }

  createOrUpdateShip(ship?: Ship): Observable<Ship> {
    if (ship?.id) {
      //update
      const url = `${this.basePath}/${ship?.id}`;
      return this.http.patch<any>(url,
        ship).pipe(map(m => {
          return m
        }));
    } else {
      //create
      return this.http.post<any>(this.basePath,
        ship
      ).pipe(map(m => {
        return m
      }));
    }
  }

  deleteShip(shipId: string): Observable<any> {
    const baseUrl = this.basePath;
    const url = `${baseUrl}/${shipId}`;
    return this.http.delete(url);
  }
}
